import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, watch, computed, getCurrentInstance, onMounted } from 'vue';
import { CountryStateSource } from '@/Sources';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryStateDropdownField',
  props: {
    value: { type: Number, required: false },
    label: { type: String, required: false, default: 'State' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false },
    countryId: { type: String, required: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: $emits }: { emit: ({ (event: 'input', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string, countryId?: string };

const instance = getCurrentInstance();





const onValueChanged = (evt: CustomEvent<number>) => {
  val.value = evt.detail;
};

const val = computed({
  get: () => props.value ?? -1,
  set: (value: number) => $emits('input', value)
});

const setSource = (countryId?: string) => {
  const dropdown = (instance?.proxy.$refs?.dropdown as HTMLSamcDropdownInputElement) ?? null;
  if (dropdown !== null) {
    if (countryId !== null && countryId !== undefined) {
      dropdown.source = new CountryStateSource(countryId) as any;
      return;
    }
    dropdown.source = [];
  }
}

watch(() => props.countryId, (newValue) => {
  setSource(newValue);
});

onMounted(() => {
  setSource(props.countryId);
});

return { __sfc: true,instance, props, $emits, onValueChanged, val, setSource }
}

})